module.exports = __webpack_public_path__ + "static/img/grow-group-test.f28d0ec7.png";